import IPosition from "@/models/dto/position.dto"
import globalModule from "@/store/modules/global.module"
import mapsModule from "@/store/modules/maps.module"
import { Feature } from "ol"
import { LineString } from "ol/geom"
import VectorLayer from "ol/layer/Vector"
import { fromLonLat } from "ol/proj"
import VectorSource from "ol/source/Vector"
import Style from "ol/style/Style"
export default class VectorService {

    static insertStyles(vectorId: number, styles: Style[]) {
        try {
            const vectorLayer: any = mapsModule.mapService.map.getLayers().getArray()[vectorId]
            vectorLayer.setStyle([])
            vectorLayer.setStyle(styles)
        } catch (error) {
            console.log('Error insert Styles in Vector')
        }
    }

    static insertFeatures(vectorId: number, features: Feature[]) {
        try {
            const vectorLayer: any = mapsModule.mapService.map.getLayers().getArray()[vectorId]
            vectorLayer.getSource().addFeatures(features)
        } catch (error) {
            console.log('Error insert Features in VectorSource')
        }
    }

    static clearVectorSource(vectorId: number) {
        try {
            const vectorSource: any = mapsModule.mapService.map.getLayers().getArray()[vectorId]
            vectorSource.getSource().clear(true)
        } catch (error) {
            console.log('Error in clear Vector')
        }
    }

    static createVectorBase(name: string, source?: any) {
        return new VectorLayer({
            // updateWhileInteracting: true,
            // updateWhileAnimating: true,
            visible: true,
            className: name,
            source: source || new VectorSource({}),
            renderBuffer: 100
        })
    }

    static centerFeaturesByLayer(layerId: number) {
        const layer: any = mapsModule.mapService.map.getLayers().getArray()[layerId]
        const features: any = layer.getSource().getFeatures()
        const points = features.map((feature: any) => {
            const coordinates = feature.getGeometry()?.getCoordinates()
            if (coordinates) return coordinates;
        }).filter((e: any) => e !== undefined)
        mapsModule.mapService.map.getView().fit(new LineString(points), { padding: [85, 85, 85, 85] });
    }

    static centerDataByLayer(layerId: number, data: IPosition[]) {
        const points = data.map(position => {
            return fromLonLat([position.longitude, position.latitude])
        })
        mapsModule.mapService.map.getView().fit(new LineString(points), { padding: [85, 85, 85, 85] });
    }

    static toggleViewLayer(layerId: number) {
        const layer: any = mapsModule.mapService.map.getLayers().getArray()[layerId]
        layer.setVisible(!layer.getVisible())
        globalModule.setRaster(layer.getVisible())
    }

    static setViewLayer(layerId: number, visible: boolean) {
        const layer: any = mapsModule.mapService.map.getLayers().getArray()[layerId]
        layer.setVisible(visible)
    }

}